import { render } from "./SchoolPage.vue?vue&type=template&id=00e6b271&ts=true"
import script from "./SchoolPage.vue?vue&type=script&lang=ts"
export * from "./SchoolPage.vue?vue&type=script&lang=ts"

import "./SchoolPage.vue?vue&type=style&index=0&id=00e6b271&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__